import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import List, {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction
} from 'material-ui/List';
import MeasureIcon from 'material-ui-icons/Straighten'

import { updatePreference } from '../../../actions';
import Select from '../../common/formComponents/Select';
import FormFrame from '../../common/FormFrame';
import { EDIT_SETTINGS_FORM } from '../../../constants/globals';
import { getLengthUnit } from '../../../reducers';
import { lengthUnits } from '../../../lib/unitConversions';
import Actions from './Actions';

const styles = theme => ({
  secondaryAction: {
    width: '33%'
  },
  fullTextField: {
    width: '100%'
  },
  fields: {
    marginBottom: theme.spacing.unit * 5
  }
});

export class Settings extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.initializeForm(props);
  }

  onSubmit(value) {
    const { updatePreference } = this.props;
    const { lengthUnit } = value;
    updatePreference({ lengthUnit })
  }

  handleSubmit(value) {
    const { handleSubmit } = this.props;
    handleSubmit(this.onSubmit)(value);
    this.handleClose();
  }

  handleClose() {
    const { history } = this.props;
    const { from } = (history.location && history.location.state) || {};
    if (from) {
      history.push(from);
    } else {
      history.push('/app');
    }
  }

  initializeForm(props) {
    const { initialize, lengthUnit } = props;
    initialize({ lengthUnit });
  }

  didcomponentDidMount() {
  }

  render () {
    const { classes } = this.props;

    return (
      <FormFrame label="Settings">
        <form onSubmit={this.handleSubmit}>
          <div className={classes.fields}>
            <Typography variant="title">
              Units
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon><MeasureIcon /></ListItemIcon>
                <ListItemText inset primary="Length" />
                <ListItemSecondaryAction className={classes.secondaryAction}>
                  <Field
                    fullWidth
                    id="lengthUnit"
                    name="lengthUnit"
                    component={Select}
                    select
                    label="length unit"
                    SelectProps={{
                      native: true
                    }}
                    margin="normal"
                    options={lengthUnits.map(({ name, symbol }) => ({ value: name, label: symbol }))}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            </List>
          </div>
          <Actions onCancel={this.handleClose} canSubmit />
        </form>
      </FormFrame>
    );
  }
}

const formConfig = {
  form: EDIT_SETTINGS_FORM,
};

const mapStateToProps = (state) => ({
  lengthUnit: getLengthUnit(state)
});

const mapDispatchToProps = {
  updatePreference
};

Settings.propTypes = {
  /* withStyles */
  classes: PropTypes.shape({
    secondaryAction: PropTypes.string,
    fullTextField: PropTypes.string,
    fields: PropTypes.string
  }).isRequired,

  /* with-router */
  history: ReactRouterPropTypes.history.isRequired,

  /* redux-form */ 
  handleSubmit: PropTypes.func.isRequired,

  /* mapDispatchToProps */
  updatePreference: PropTypes.func.isRequired,
};

export default compose(
  withRouter,
  withStyles(styles),
  reduxForm(formConfig),
  connect(mapStateToProps, mapDispatchToProps)
) (Settings);




// WEBPACK FOOTER //
// ./src/components/StackupDesign/Settings/Settings.jsx